import { useEffect } from "react";
import { useNavigateWithParams } from "../../../hooks/useNavigateWithParams";
import { useAppSelector } from "../../../rtk/_config/hooks";
import { RootState } from "../../../types/rtk/api-config/types";
import { AppRoutes } from "../../../routes/AppRoutes";

const Home = () => {
  const navigate = useNavigateWithParams();
  const offer_id = useAppSelector((state: RootState) => state.basket.offer_id);

  useEffect(() => {
    // If subscription already selected (from cache), go directly to Options
    if (offer_id !== null) {
      navigate(AppRoutes.OPTIONS);
    } else {
      navigate(AppRoutes.SUBSCRIPTIONS);
    }
  }, [navigate, offer_id]);

  return null;
};

export default Home;